<template>
    <div class="video-wrapper" :class="status">
        <video :src="src" ref="video" :controls="controls" @ended="ended"></video>

        <div class="video-play" @click="play">
            <span v-html="$t('Play video')"></span>
            <span class="_icon">
                <img src="/svg/play.svg" alt="">
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        src: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            video: null,
            controls: false,
            status: null
        }
    },

    mounted() {
        this.video = this.$refs.video
    },

    methods: {
        play() {
            this.video.play()
            this.status = 'is-playing'
            this.controls = true
        },

        ended(e) {
            this.status = null
            this.controls = false
            this.video.load()
        }
    }
}
</script>
